<template >
    <v-col class="pa-0 ma-0 secondary" :style="{ position: 'absolute', bottom: '0', zIndex: tabBarActive ? 1000 : -1,  height: '34vh' }" v-if="tabBarActive">
        <div style="position:relative;">
            <v-autocomplete return-object style="" dense filled :items="zones" v-model="zoneSelected" @change="changeZone(zoneSelected)" hide-details />
        </div>
        <v-tabs fixed-tabs v-model="tab">
            <!-- Planning -->
            <v-tab>
                <v-row>
                    <v-col cols="1">
                        <v-icon>mdi-tractor</v-icon>
                    </v-col>
                    <v-col>
                        <h3>
                            Planning
                        </h3>
                        <!-- <h4>
                            20%
                        </h4> -->
                    </v-col>
                </v-row>
            </v-tab>
            <v-tab>
                <v-row>
                    <v-col cols="1">
                        <v-icon>mdi-thermometer</v-icon>
                    </v-col>
                    <v-col>
                        <h3>
                            Température
                        </h3>
                        <!-- <h4>
                            20°C
                        </h4> -->
                    </v-col>
                </v-row>
            </v-tab>
            <v-tab>
                <v-row>
                    <v-col cols="1">
                        <v-icon>mdi-weather-windy</v-icon>
                    </v-col>
                    <v-col>
                        <h3>
                            Vents
                        </h3>
                        <!-- <h4>
                            20km/h
                        </h4> -->
                    </v-col>
                </v-row>
            </v-tab>
            <v-tab>
                <v-row>
                    <v-col cols="1">
                        <v-icon>mdi-weather-windy</v-icon>
                    </v-col>
                    <v-col>
                        <h3>
                            Pluie
                        </h3>
                        <!-- <h4>
                            10mm/h
                        </h4> -->
                    </v-col>
                </v-row>
            </v-tab>
            <!-- BioMass -->
            <v-tab v-if="false">
                <v-row>
                    <v-col cols="1">
                        <v-icon>mdi-leaf</v-icon>
                    </v-col>
                    <v-col>
                        <h3>
                            Biomasse
                        </h3>
                        <h4>
                            20%
                        </h4>
                    </v-col>
                </v-row>
            </v-tab>
            
        </v-tabs>
        <v-tabs-items v-model="tab" style="min-height: 300px;max-height: 300px; overflow: scroll;" >
            <v-tab-item>
                <planning-chart />
            </v-tab-item>
            <v-tab-item>
                <weather-chart param="temperature_2m" @lastData="changeLastData('temperature_2m', $event)" unit="°C" />
            </v-tab-item>
            <v-tab-item>
                <weather-chart param="windspeed_10m" @lastData="changeLastData('windspeed_10m', $event)" unit="km/h" />
            </v-tab-item>
            <v-tab-item>
                <weather-chart param="rain" @lastData="changeLastData('rain', $event)" :type="'column'" unit="mm/h" />
            </v-tab-item>
            <v-tab-item v-if="false">
                <weather-chart :biomass="true" @lastData="changeLastData('biomass', $event)" unit="%" />
            </v-tab-item>
            
        </v-tabs-items>



    </v-col>
</template>

<script>
import WeatherChart from '@/components/Charts/WeatherChart.vue';
import PlanningChart from '@/components/Charts/PlanningChart.vue';
import { mapGetters, mapState, mapActions } from 'vuex';
import { VAutocomplete } from 'vuetify/lib';
export default {
    name: 'TabBar',
    computed: {
        ...mapGetters(["getZones",'getTabBarActive']),
        ...mapState(["zoneSelected",'tabBarActive']),
        
        tabBarActive() {
          return this.getTabBarActive; // Rendre plus lisible
        },
        zoneSelected: {
            get() {
                return this.$store.state.zoneSelected
            },
            set(value) {
                this.$store.commit("setZoneSelected", value)
            }
        },
        zones: {
            get() {
                return this.$store.getters.getZones
            }
        }
    },
    components: {
    WeatherChart,
    PlanningChart,
    VAutocomplete
},
    data: () => ({
        tab: 0
    }),
    methods: {
        ...mapActions(['toggleTabBar']), // Modifier la valeur via Vuex
        changeZone(zone) {
            // console.log('zone',zone)
            this.$store.commit("setZoneSelected", zone)
        },
        changeLastData(param, data) {
            console.log(param, data)
        }
    }
};
</script>